import axios from 'axios';
import { config } from '../libs/config/config';

export const getBaseUrl = () => config.api.rootUrl;

const axiosInstance = axios.create({
  baseURL: getBaseUrl(),
  validateStatus: (status) => status < 500, // 500未満のステータスで例外を投げない
});

// todo インターセプター設定

export const getAxiosInstance = () => axiosInstance;
